import { gql } from '../types/generated';

export const MILESTONES_SCHEDULE = gql(`
  query milestonesSchedule($date: String = "", $sports: [Sport] = [MLB]) {
    schedule(date: $date, sports: $sports) {
      away {
        ...TeamFields
      }
      home {
        ...TeamFields
      }
      venue {
        id
        name
      }
      gameDate
      gamePk
      status
      pipelines {
        id
      }
      content {
        mediaId
        mediaState {
          state
        }
      }
    }
  }
`);

export const GET_MILESTONES_GAME = gql(`
  query milestonesGame($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      gamePk
      pipelines {
        id
        streamState
        media {
          id
        }
      }
      content {
        callSign
        feedType
        mediaId
        mediaState {
          mediaType
        }
      }
    }
  }
`);

export const GET_MILESTONE_SCHEMAS = gql(`
  query milestoneSchemas {
    milestoneSchemas {
      name
      displayName
      description
      metadataFields {
        name
        displayName
        description
        type
      }
    }
  }
`);

export const GET_MILESTONES = gql(`
  query milestones($mediaId: String!) {
    milestones(mediaId: $mediaId) {
      id
      milestoneType
      absoluteTime
      title
      updatedBy
      keywords {
        name
        value
      }
    }
  }
`);
